import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { useFormikContext } from "formik";
import { Box, Typography } from "@mui/material";

export default function PasswordRequirements({ name = "password" }) {
  const { values } = useFormikContext();
  const password = values[name] || "";

  const rules = [
    {
      label: "At least 8 characters",
      valid: password.length >= 8,
    },
    {
      label: "Contains a capital letter (A-Z)",
      valid: /[A-Z]/.test(password),
    },
    {
      label: "Contains a number (0-9)",
      valid: /\d/.test(password),
    },
    {
      label: "Contains a special character (!@#$...)",
      valid: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    },
  ];
  return (
    <Box sx={{ mt: 0.5 }}>
      {rules.map((rule, index) => (
        <Box
          key={index}
          sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.2 }}
        >
          {rule.valid ? (
            <CheckCircleIcon color="success" fontSize="small" />
          ) : (
            <CancelIcon color="disabled" fontSize="small" />
          )}
          <Typography
            variant="body2"
            color={rule.valid ? "success.main" : "text.secondary"}
          >
            {rule.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
